import { render, staticRenderFns } from "./DashFilters.vue?vue&type=template&id=8377d6da&scoped=true"
import script from "./DashFilters.vue?vue&type=script&lang=js"
export * from "./DashFilters.vue?vue&type=script&lang=js"
import style0 from "./DashFilters.vue?vue&type=style&index=0&id=8377d6da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8377d6da",
  null
  
)

export default component.exports